/**
 *  interface for Login Type
 */
export enum ProfileTypes {
  VIEW_PROFILE = '@@profile/VIEW_PROFILE',
  EDIT_PROFILE = '@@profile/EDIT_PROFILE',
  PROFILE_SUCCESS = '@@profile/PROFILE_SUCCESS',
  PROFILE_ERROR = '@@profile/PROFILE_ERROR',
  RESET_PROFILE_FLAG = '@@profile/RESET_PROFILE_FLAG',
  UPDATE_PROFILE_PICTURE = '@@profile/UPDATE_PROFILE_PICTURE',
  UPDATE_PROFILE_PICTURE_SUCCESS = '@@profile/UPDATE_PROFILE_PICTURE_SUCCESS',
}
